import React from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button, Box, Typography } from "@mui/material"

const OwnerPopulationSummary = ({
    animals,
    owner,
    setStep,
    setSelectedData,
    setTitle,
    lastUpdatedDate,
    setIsLoading,
    createInventory,
    success,
    error,
    getOwnerPopulationDetailed,
    getInventories,
    setFetchedInventories,
}) => {
    const {
        registeredInFlock,
        maleAliveAnimals,
        maleAliveAnimalsDetails,
        femaleAliveAnimals,
        femaleAliveAnimalsDetails,
        animalsNeverLambed,
        animalsNeverLambedDetails,
        animalsLambedBeforeButNotInPeriod,
        animalsLambedBeforeButNotInPeriodDetails,
        animalsLambedInPeriod,
        animalsLambedInPeriodDetails,
        lambingCategories,
        age12Months,
        age12MonthsDetails,
        age14Months,
        age14MonthsDetails,
        aliveLambs,
        aliveLambsDetails,
        maleAliveLambs,
        maleAliveLambsDetails,
        femaleAliveLambs,
        femaleAliveLambsDetails,
        maleDeadLambs,
        femaleDeadLambs,
        animalsLambedAtLeastOnce,
        animalsLambedAtLeastOnceDetails,
    } = animals;

    const { code, lastName, firstName, address, county } = owner;

    const handleViewDetails = (viewData, title) => {
        setSelectedData(viewData);
        setTitle(title);
        setStep(3);
    };

    const handleCreateInventory = async () => {
        setIsLoading(true);
        try {
            const currentYear = new Date().getFullYear();
            const startYear = currentYear - 1;
            const { success: scs, animals, message } = await getOwnerPopulationDetailed(owner._id, startYear);
            if (scs) {
                const valuesToSend = {
                    owner: owner?._id,
                    censusDate: new Date().toLocaleDateString("el-GR"),
                    aliveAnimals: animals?.maleAliveAnimals + animals?.femaleAliveAnimals,
                    registeredInFlock: animals?.registeredInFlock,
                    maleAlive: animals?.maleAliveAnimals,
                    femaleAlive: animals?.femaleAliveAnimals,
                    animalsNeverLambed: animals?.animalsNeverLambed,
                    animalsNotLambedInPeriod: animals?.animalsLambedBeforeButNotInPeriod,
                    animalsLambedInPeriod: animals?.animalsLambedInPeriod,
                    aliveLambs: animals?.aliveLambs,
                    maleAliveLambs: animals?.maleAliveLambs,
                    femaleAliveLambs: animals?.femaleAliveLambs,
                    maleDeadLambs: animals?.maleDeadLambs,
                    femaleDeadLambs: animals?.femaleDeadLambs,
                    animalsLambedAtLeastOnce: animals?.animalsLambedAtLeastOnce,
                };
                const { success: scs, message } = await createInventory(valuesToSend);
                if (scs) {
                    success(message);
                } else {
                    error(message);
                }
            } else {
                error(message);
            }
        } catch (err) {
            error(err);
        }
        setIsLoading(false);
    }

    const handleGetInventories = async () => {
        setIsLoading(true);
        const { success: scs, inventories, message } = await getInventories(owner?._id);
        if (scs) {
            setFetchedInventories(inventories);
            setStep(5);
        } else {
            error(message);
        }
        setIsLoading(false);
    }
    const currentDate = new Date().toLocaleDateString("el-GR");

    return (
        <div>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 2, width: "80%" }}>
                <Typography variant="h5" gutterBottom>
                    <strong>Στοιχεία Πληθυσμού</strong>
                </Typography>
                <Box sx={{ display: 'flex', gap: 2 }}>
                    <Button variant="outlined" onClick={() => handleGetInventories()}>Λίστα απογραφών</Button>
                    <Button variant="outlined" onClick={() => setStep(4)}>Εκτύπωση</Button>
                </Box>
            </Box>

            {/* Owner Details Box */}
            <Box sx={{ marginBottom: 3, padding: 2, backgroundColor: "#f5f5f5", borderRadius: "8px", width: "80%" }}>
                <Typography variant="h6" gutterBottom>
                    Στοιχεία Εκτροφής
                </Typography>
                <Typography variant="body1">
                    <strong>Κωδικός Εκτροφής:</strong> {code}
                </Typography>
                <Typography variant="body1">
                    <strong>Όνομα Παραγωγού:</strong> {lastName} {firstName}
                </Typography>
                <Typography variant="body1">
                    <strong>Διεύθυνση Εκτροφής:</strong> {address}
                </Typography>
                <Typography variant="body1">
                    <strong>Νομός Εκτροφής:</strong> {county}
                </Typography>
                <Typography variant="body1">
                    <strong>Ημερομηνία Τελευταίας Ενημέρωσης:</strong> {new Date(lastUpdatedDate).toLocaleDateString("el-GR")}
                </Typography>
            </Box>

            {/* Καταγραφή Στοιχείων Button with Date */}
            <Box sx={{ marginBottom: 3, width: "80%", display: "flex", flexDirection: "column", alignItems: "center" }}>
                <Typography variant="body1" sx={{ marginBottom: 1 }}>
                    <strong>Ημερομηνία Καταγραφής:</strong> {currentDate}
                </Typography>
                <Button variant="contained" onClick={() => handleCreateInventory()}>Καταγραφή Στοιχείων</Button>
            </Box>

            {/* Population Table */}
            <TableContainer sx={{ width: "80%" }}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell><strong></strong></TableCell>
                            <TableCell sx={{ fontSize: 18 }}><strong>Στοιχεία Απογραφής</strong></TableCell>
                            <TableCell><strong></strong></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell>Δυναμικό Εκτροφής</TableCell>
                            <TableCell align="right">{maleAliveAnimals + femaleAliveAnimals}</TableCell>
                            <TableCell align="right">{""}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Καταγεγραμμένα στην Εκτροφή</TableCell>
                            <TableCell align="right">{registeredInFlock}</TableCell>
                            <TableCell><strong></strong></TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Αρσενικά ζώα</TableCell>
                            <TableCell align="right">{maleAliveAnimals}</TableCell>
                            <TableCell align="center"><Button onClick={() => handleViewDetails(maleAliveAnimalsDetails, "Αρσενικά Ζώα")}>Προβολή</Button></TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Θηλυκά ζώα</TableCell>
                            <TableCell align="right">{femaleAliveAnimals}</TableCell>
                            <TableCell align="center"><Button onClick={() => handleViewDetails(femaleAliveAnimalsDetails, "Θηλυκά Ζώα")}>Προβολή</Button></TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Ζυγούρια</TableCell>
                            <TableCell align="right">{animalsNeverLambed}</TableCell>
                            <TableCell align="center"><Button onClick={() => handleViewDetails(animalsNeverLambedDetails, "Ζυγούρια")}>Προβολή</Button></TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Προβατίνες</TableCell>
                            <TableCell align="right">{animalsLambedAtLeastOnce}</TableCell>
                            <TableCell align="center"><Button onClick={() => handleViewDetails(animalsLambedAtLeastOnceDetails, "Θηλυκά ζώα με γέννα")}>Προβολή</Button></TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Στέρφα</TableCell>
                            <TableCell align="right">{animalsLambedBeforeButNotInPeriod}</TableCell>
                            <TableCell align="center"><Button onClick={() => handleViewDetails(animalsLambedBeforeButNotInPeriodDetails, "Στέρφα")}>Προβολή</Button></TableCell>
                        </TableRow>
                        {age12Months !== 0 && (
                            <TableRow>
                                <TableCell>{"Ηλικία > 12 μήνες"}</TableCell>
                                <TableCell align="right">{age12Months}</TableCell>
                                <TableCell align="center"><Button onClick={() => handleViewDetails(age12MonthsDetails, "Θηλυκά Ζώα με Ηλικία > 12 μήνες")}>Προβολή</Button></TableCell>
                            </TableRow>
                        )}
                        {age14Months !== 0 && (
                            <TableRow>
                                <TableCell>{"Ηλικία > 14 μήνες"}</TableCell>
                                <TableCell align="right">{age14Months}</TableCell>
                                <TableCell align="center"><Button onClick={() => handleViewDetails(age14MonthsDetails, "Θηλυκά Ζώα με Ηλικία > 14 μήνες")}>Προβολή</Button></TableCell>
                            </TableRow>
                        )}
                        <TableRow>
                            <TableCell>{"Σε γαλ/γη"}</TableCell>
                            <TableCell align="right">{animalsLambedInPeriod}</TableCell>
                            <TableCell align="center"><Button onClick={() => handleViewDetails(animalsLambedInPeriodDetails, "Προβατίνες σε γαλακτοπαραγωγή")}>Προβολή</Button></TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>1η γαλακτική περίοδο</TableCell>
                            <TableCell align="right">{lambingCategories?.firstLambing}</TableCell>
                            <TableCell><strong></strong></TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>2η γαλακτική περίοδο</TableCell>
                            <TableCell align="right">{lambingCategories?.secondLambing}</TableCell>
                            <TableCell><strong></strong></TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>3η γαλακτική περίοδο</TableCell>
                            <TableCell align="right">{lambingCategories?.thirdLambing}</TableCell>
                            <TableCell><strong></strong></TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>4η γαλακτική περίοδο</TableCell>
                            <TableCell align="right">{lambingCategories?.fourthLambing}</TableCell>
                            <TableCell><strong></strong></TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>5η και άνω γαλακτική περίοδο</TableCell>
                            <TableCell align="right">{lambingCategories?.fifthOrMoreLambing}</TableCell>
                            <TableCell><strong></strong></TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Αμνοί</TableCell>
                            <TableCell align="right">{aliveLambs}</TableCell>
                            <TableCell align="center"><Button onClick={() => handleViewDetails(aliveLambsDetails, "Αμνοί")}>Προβολή</Button></TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Αρσενικά ζωντανά</TableCell>
                            <TableCell align="right">{maleAliveLambs}</TableCell>
                            <TableCell align="center"><Button onClick={() => handleViewDetails(maleAliveLambsDetails, "Αρσενικά ζωντανά αμνοί")}>Προβολή</Button></TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Αρσενικά νεκρά</TableCell>
                            <TableCell align="right">{maleDeadLambs}</TableCell>
                            <TableCell><strong></strong></TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Θηλυκά ζωντανά</TableCell>
                            <TableCell align="right">{femaleAliveLambs}</TableCell>
                            <TableCell align="center"><Button onClick={() => handleViewDetails(femaleAliveLambsDetails, "Θηλυκά ζωντανά αμνοί")}>Προβολή</Button></TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Θηλυκά νεκρά</TableCell>
                            <TableCell align="right">{femaleDeadLambs}</TableCell>
                            <TableCell><strong></strong></TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>

            {/* Back Button */}
            <Box sx={{ width: "80%", marginTop: 3, marginBottom: 3, display: "flex", justifyContent: "center" }}>
                <Button variant="outlined" color="secondary" onClick={() => setStep(1)}>
                    Πίσω
                </Button>
            </Box>

        </div>
    );
};

export default OwnerPopulationSummary;
